
import { FeatureCollection } from '../../../../shared/types/MapShapes';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Button from '../../../../core/components/Generics/Button.vue';
import SimpleMap from '../../../../core/components/Map/SimpleMap.vue';
import { MapType } from '../../../../core/components/Map/map-type';


@Component({
  components: {
    Button,
    SimpleMap
    
  }
})
export default class MapPolygons extends Vue {
  /** La vista de suscripción arranca en satélite en todos los clientes (no depende de `features.satelliteMapByDefault`). */
  mapType: MapType = MapType.Hybrid;
  @Prop({default: null}) geojsonData: FeatureCollection
  @Prop({default(){return []}}) selectedItems: Array<object>
  @Prop({default: false}) visible: boolean


  @Emit()
  closeModal() {}
  
  @Emit()
  onSelectedRanchs(selectedPolygons) {}

  
}
